export default "__VITE_ASSET__DPlhr7wI__"